// // // // // // import React, { useState } from "react";

// // // // // // const posts = [
// // // // // //   {
// // // // // //     id: 1,
// // // // // //     type: "image",
// // // // // //     thumbnail: "https://bakelore.com/cdn/shop/files/post1.jpg",
// // // // // //     caption:
// // // // // //       "Kaju Katli and Motichoor Laddu - reimagined into indulgent Desserts at Bakelore. Where festive classics meet modern patisserie artistry.",
// // // // // //     hashtags: "#bakelore #kajukatli #motichoor",
// // // // // //   },
// // // // // //   {
// // // // // //     id: 2,
// // // // // //     type: "video",
// // // // // //     thumbnail: "https://bakelore.com/cdn/shop/files/post2.jpg",
// // // // // //     video: "https://bakelore.com/cdn/shop/files/video1.mp4",
// // // // // //     caption:
// // // // // //       "Festive gifting with Bakelore – a taste of joy and celebration in every bite.",
// // // // // //     hashtags: "#bakelore #desserts #gifting",
// // // // // //   },
// // // // // //   {
// // // // // //     id: 3,
// // // // // //     type: "image",
// // // // // //     thumbnail: "https://bakelore.com/cdn/shop/files/post3.jpg",
// // // // // //     caption: "Kaju Katli Reimagined!",
// // // // // //     hashtags: "#kajukatli #modernpatisserie",
// // // // // //   },
// // // // // //   // Add more posts as needed
// // // // // // ];

// // // // // // export default function InstagramFeed() {
// // // // // //   const [selected, setSelected] = useState(null);

// // // // // //   return (
// // // // // //     <section className="py-10 bg-white">
// // // // // //       <h2 className="text-center text-3xl font-semibold text-gray-800 mb-8">
// // // // // //         Follow us on instagram
// // // // // //       </h2>

// // // // // //       {/* Grid */}
// // // // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 px-4 md:px-8">
// // // // // //         {posts.map((post) => (
// // // // // //           <div
// // // // // //             key={post.id}
// // // // // //             className="relative cursor-pointer group overflow-hidden"
// // // // // //             onClick={() => setSelected(post)}
// // // // // //           >
// // // // // //             <img
// // // // // //               src={post.thumbnail}
// // // // // //               alt="instagram post"
// // // // // //               className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
// // // // // //             />
// // // // // //             {/* Overlay on hover */}
// // // // // //             <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity">
// // // // // //               {post.type === "video" && (
// // // // // //                 <svg
// // // // // //                   xmlns="http://www.w3.org/2000/svg"
// // // // // //                   fill="white"
// // // // // //                   viewBox="0 0 24 24"
// // // // // //                   strokeWidth={1.5}
// // // // // //                   stroke="white"
// // // // // //                   className="w-10 h-10"
// // // // // //                 >
// // // // // //                   <path
// // // // // //                     strokeLinecap="round"
// // // // // //                     strokeLinejoin="round"
// // // // // //                     d="M5.25 5.25v13.5l13.5-6.75L5.25 5.25z"
// // // // // //                   />
// // // // // //                 </svg>
// // // // // //               )}
// // // // // //             </div>
// // // // // //           </div>
// // // // // //         ))}
// // // // // //       </div>

// // // // // //       {/* Modal */}
// // // // // //       {selected && (
// // // // // //         <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center">
// // // // // //           <div className="bg-white rounded-lg overflow-hidden shadow-lg w-[90%] max-w-5xl relative">
// // // // // //             <button
// // // // // //               onClick={() => setSelected(null)}
// // // // // //               className="absolute top-3 right-3 text-gray-700 hover:text-black text-3xl font-light"
// // // // // //             >
// // // // // //               ×
// // // // // //             </button>

// // // // // //             <div className="grid grid-cols-1 md:grid-cols-2">
// // // // // //               {/* Left Media */}
// // // // // //               <div className="bg-black flex items-center justify-center">
// // // // // //                 {selected.type === "video" ? (
// // // // // //                   <video
// // // // // //                     src={selected.video}
// // // // // //                     controls
// // // // // //                     autoPlay
// // // // // //                     className="w-full h-full object-contain"
// // // // // //                   />
// // // // // //                 ) : (
// // // // // //                   <img
// // // // // //                     src={selected.thumbnail}
// // // // // //                     alt="post"
// // // // // //                     className="w-full h-full object-cover"
// // // // // //                   />
// // // // // //                 )}
// // // // // //               </div>

// // // // // //               {/* Right Info */}
// // // // // //               <div className="p-6 flex flex-col justify-between">
// // // // // //                 <div>
// // // // // //                   <div className="flex items-center gap-3 mb-3">
// // // // // //                     <div className="w-10 h-10 rounded-full border flex items-center justify-center font-semibold">
// // // // // //                       <img
// // // // // //                         src="https://bakelore.com/cdn/shop/files/logo_64x64.png"
// // // // // //                         alt="bakelore"
// // // // // //                         className="rounded-full"
// // // // // //                       />
// // // // // //                     </div>
// // // // // //                     <h3 className="font-medium text-gray-900">
// // // // // //                       bakelore.in
// // // // // //                     </h3>
// // // // // //                   </div>
// // // // // //                   <p className="text-gray-700 mb-4 leading-relaxed">
// // // // // //                     {selected.caption}
// // // // // //                   </p>
// // // // // //                   <p className="text-gray-500 text-sm">
// // // // // //                     {selected.hashtags}
// // // // // //                   </p>
// // // // // //                 </div>
// // // // // //                 <p className="text-xs text-gray-400 mt-6">
// // // // // //                   14 October • View on Instagram
// // // // // //                 </p>
// // // // // //               </div>
// // // // // //             </div>
// // // // // //           </div>
// // // // // //         </div>
// // // // // //       )}
// // // // // //     </section>
// // // // // //   );
// // // // // // }


// // // // // // import React from "react";
// // // // // // import { FaInstagram } from "react-icons/fa";

// // // // // // const InstagramGrid = () => {
// // // // // //   const images = [
// // // // // //     "http://bakelore.com/images/insta/insta1-min.jpg",
// // // // // //     "http://bakelore.com/images/insta/insta2-min.jpg",
// // // // // //     "http://bakelore.com/images/insta/insta3-min.jpg",
// // // // // //     "http://bakelore.com/images/insta/insta4-min.jpg",
// // // // // //     "http://bakelore.com/images/insta/insta5-min.jpg",
// // // // // //     "http://bakelore.com/images/insta/insta6-min.jpg",
// // // // // //   ];

// // // // // //   return (
// // // // // //     <section className="bg-[#faf7f2] py-16 px-6 md:px-20">
// // // // // //       {/* Title */}
// // // // // //       <div className="text-center mb-10">
// // // // // //         <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
// // // // // //           Follow us on Instagram
// // // // // //         </h2>
// // // // // //         <p className="text-gray-600 mt-2">
// // // // // //           Explore our latest moments & treats
// // // // // //         </p>
// // // // // //       </div>

// // // // // //       {/* Grid */}
// // // // // //       <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-5 max-w-7xl mx-auto">
// // // // // //         {images.map((img, index) => (
// // // // // //           <div
// // // // // //             key={index}
// // // // // //             className="relative overflow-hidden rounded-lg group cursor-pointer"
// // // // // //           >
// // // // // //             <img
// // // // // //               src={img}
// // // // // //               alt={`Instagram ${index + 1}`}
// // // // // //               className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
// // // // // //             />
// // // // // //             {/* Overlay */}
// // // // // //             <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
// // // // // //               <FaInstagram className="text-white text-3xl" />
// // // // // //             </div>
// // // // // //           </div>
// // // // // //         ))}
// // // // // //       </div>

// // // // // //       {/* Follow Button */}
// // // // // //       <div className="text-center mt-10">
// // // // // //         <a
// // // // // //           href="https://www.instagram.com/yourusername/"
// // // // // //           target="_blank"
// // // // // //           rel="noopener noreferrer"
// // // // // //           className="inline-block bg-[#e4405f] text-white px-6 py-3 rounded-full font-semibold text-lg hover:bg-[#d93755] transition-all duration-300 shadow-md"
// // // // // //         >
// // // // // //           Follow @yourusername
// // // // // //         </a>
// // // // // //       </div>
// // // // // //     </section>
// // // // // //   );
// // // // // // };

// // // // // // export default InstagramGrid;



// // // // // import React, { useState } from "react";
// // // // // import { FaInstagram } from "react-icons/fa";

// // // // // const posts = [
// // // // //   {
// // // // //     id: 1,
// // // // //     image: "/images/kaju-katli.jpg",
// // // // //     title: "Kaju Katli Reimagined!",
// // // // //     caption: `A divine fusion of tradition and indulgence! Buttery chocolate blondies meet the royal richness of kaju katli, creating a melt-in-the-mouth treat that’s nutty, fudgy, and festive in every bite.

// // // // // Perfectly balanced with the sweetness of cashews and the decadence of chocolate, this limited-edition delight is crafted to make your Diwali celebrations extra special.

// // // // // #diwali #diwalidesserts`,
// // // // //   },
// // // // //   {
// // // // //     id: 2,
// // // // //     image: "/images/ladoo.jpg",
// // // // //     title: "Laddu. Cookie. Celebration.",
// // // // //     caption: "Celebrate the sweetness of Diwali with our festive collection!",
// // // // //   },
// // // // //   {
// // // // //     id: 3,
// // // // //     image: "/images/dessert-box.jpg",
// // // // //     title: "Festive Dessert Box",
// // // // //     caption:
// // // // //       "A box full of handcrafted sweets to make your Diwali brighter and sweeter!",
// // // // //   },
// // // // // ];

// // // // // const InstagramGrid = () => {
// // // // //   const [selectedPost, setSelectedPost] = useState(null);

// // // // //   return (
// // // // //     <div className="w-full bg-white">
// // // // //       {/* Grid Layout */}
// // // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 p-4">
// // // // //         {posts.map((post) => (
// // // // //           <div
// // // // //             key={post.id}
// // // // //             className="relative overflow-hidden cursor-pointer group"
// // // // //             onClick={() => setSelectedPost(post)}
// // // // //           >
// // // // //             <img
// // // // //               src={post.image}
// // // // //               alt={post.title}
// // // // //               className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // // //             />
// // // // //             {/* Overlay */}
// // // // //             <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-white text-center">
// // // // //               <FaInstagram className="text-3xl mb-2" />
// // // // //               <p className="text-sm font-medium">{post.title}</p>
// // // // //             </div>
// // // // //           </div>
// // // // //         ))}
// // // // //       </div>

// // // // //       {/* Popup Modal */}
// // // // //       {selectedPost && (
// // // // //         <div
// // // // //           className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
// // // // //           onClick={() => setSelectedPost(null)}
// // // // //         >
// // // // //           <div
// // // // //             className="bg-white rounded-lg overflow-hidden w-[90%] md:w-[80%] lg:w-[60%] max-h-[90vh] flex flex-col md:flex-row"
// // // // //             onClick={(e) => e.stopPropagation()}
// // // // //           >
// // // // //             {/* Left Image */}
// // // // //             <div className="md:w-1/2 w-full h-64 md:h-auto">
// // // // //               <img
// // // // //                 src={selectedPost.image}
// // // // //                 alt={selectedPost.title}
// // // // //                 className="w-full h-full object-cover"
// // // // //               />
// // // // //             </div>

// // // // //             {/* Right Content */}
// // // // //             <div className="p-6 flex flex-col overflow-y-auto md:w-1/2">
// // // // //               <div className="flex items-center gap-2 mb-4">
// // // // //                 <FaInstagram className="text-2xl text-gray-700" />
// // // // //                 <span className="font-semibold text-gray-800">bakelore.in</span>
// // // // //               </div>

// // // // //               <p className="whitespace-pre-line text-gray-700 text-sm leading-relaxed">
// // // // //                 {selectedPost.caption}
// // // // //               </p>

// // // // //               <button
// // // // //                 onClick={() => setSelectedPost(null)}
// // // // //                 className="mt-6 self-end bg-gray-900 text-white px-4 py-2 rounded-md hover:bg-gray-800 text-sm"
// // // // //               >
// // // // //                 Close
// // // // //               </button>
// // // // //             </div>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default InstagramGrid;



// // // // // import React, { useState } from "react";
// // // // // import { FaInstagram } from "react-icons/fa";
// // // // // import { InstagramEmbed } from "react-social-media-embed";

// // // // // const posts = [
// // // // //   { id:1, url:"https://www.instagram.com/reel/DP0rVIJCdXe/", title:"Some reel title" },
// // // // //   { id:2, url:"https://www.instagram.com/p/DPY-erQiWF_/?img_index=1", title:"Post title 2" },
// // // // //   { id:3, url:"https://www.instagram.com/p/DPGh0m9CSeF/?img_index=1", title:"Post title 3" },
// // // // //   { id:4, url:"https://www.instagram.com/p/DPBJZHdCWmX/", title:"Post title 4" },
// // // // //   { id:5, url:"https://www.instagram.com/p/DLouU6zvrq3/", title:"Post title 5" },
// // // // //   { id:6, url:"https://www.instagram.com/p/DKbec6_uJoc/", title:"Post title 6" },
// // // // //   { id:7, url:"https://www.instagram.com/p/DPv1QKgCQT0/", title:"Post title 7" },
// // // // // ];

// // // // // const InstagramGrid = () => {
// // // // //   const [selectedPost, setSelectedPost] = useState(null);

// // // // //   return (
// // // // //     <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 p-4">
// // // // //       {posts.map(post => (
// // // // //         <div key={post.id}
// // // // //              className="relative cursor-pointer group overflow-hidden"
// // // // //              onClick={()=>setSelectedPost(post)}>
// // // // //           {/* Use a thumbnail or placeholder image here, or embed mini version */}
// // // // //           <div className="w-full h-60 bg-gray-200 flex items-center justify-center">
// // // // //             <FaInstagram className="text-4xl text-gray-500"/>
// // // // //           </div>
// // // // //           <div className="absolute inset-0 bg-black/50 flex flex-col items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-white">
// // // // //             <FaInstagram className="text-3xl mb-2"/>
// // // // //             <p className="text-sm tracking-wide">{post.title}</p>
// // // // //           </div>
// // // // //         </div>
// // // // //       ))}

// // // // //       {selectedPost && (
// // // // //         <div className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center"
// // // // //              onClick={()=>setSelectedPost(null)}>
// // // // //           <div className="bg-white w-[90%] md:w-[80%] lg:w-[60%] rounded-xl overflow-hidden"
// // // // //                onClick={e=>e.stopPropagation()}>
// // // // //             <InstagramEmbed url={selectedPost.url} width="100%" captioned />
// // // // //             <button className="mt-4 mb-2 px-4 py-2 bg-gray-900 text-white rounded-lg hover:bg-gray-800"
// // // // //                     onClick={()=>setSelectedPost(null)}>
// // // // //               Close
// // // // //             </button>
// // // // //           </div>
// // // // //         </div>
// // // // //       )}
// // // // //     </div>
// // // // //   );
// // // // // };

// // // // // export default InstagramGrid;


// // // // import React, { useState } from "react";
// // // // import { FaInstagram } from "react-icons/fa";
// // // // import { InstagramEmbed } from "react-social-media-embed";

// // // // // ✅ Each post has: id, url (for popup), image (thumbnail), and title
// // // // const posts = [
// // // //   {
// // // //     id: 1,
// // // //     url: "https://www.instagram.com/reel/DP0rVIJCdXe/",
// // // //     image: "https://www.instagram.com/p/DP0rVIJCdXe/media/?size=l",
// // // //     title: "Reel — Bakelore Experience",
// // // //   },
// // // //   {
// // // //     id: 2,
// // // //     url: "https://www.instagram.com/p/DPY-erQiWF_/?img_index=1",
// // // //     image: "https://www.instagram.com/p/DPY-erQiWF_/media/?size=l",
// // // //     title: "Sweet Chocolate Layer",
// // // //   },
// // // //   {
// // // //     id: 3,
// // // //     url: "https://www.instagram.com/p/DPGh0m9CSeF/?img_index=1",
// // // //     image: "https://www.instagram.com/p/DPGh0m9CSeF/media/?size=l",
// // // //     title: "Dessert Perfection",
// // // //   },
// // // //   {
// // // //     id: 4,
// // // //     url: "https://www.instagram.com/p/DPBJZHdCWmX/",
// // // //     image: "https://www.instagram.com/p/DPBJZHdCWmX/media/?size=l",
// // // //     title: "Festive Treats",
// // // //   },
// // // //   {
// // // //     id: 5,
// // // //     url: "https://www.instagram.com/p/DLouU6zvrq3/",
// // // //     image: "https://www.instagram.com/p/DLouU6zvrq3/media/?size=l",
// // // //     title: "Signature Pastries",
// // // //   },
// // // //   {
// // // //     id: 6,
// // // //     url: "https://www.instagram.com/p/DKbec6_uJoc/",
// // // //     image: "https://www.instagram.com/p/DKbec6_uJoc/media/?size=l",
// // // //     title: "Luxury Cakes",
// // // //   },
// // // //   {
// // // //     id: 7,
// // // //     url: "https://www.instagram.com/p/DPv1QKgCQT0/",
// // // //     image: "https://www.instagram.com/p/DPv1QKgCQT0/media/?size=l",
// // // //     title: "Coffee Moments",
// // // //   },
// // // // ];

// // // // const InstagramGrid = () => {
// // // //   const [selectedPost, setSelectedPost] = useState(null);

// // // //   return (
// // // //     <section className="bg-white py-8">
// // // //       {/* === Instagram Feed Grid === */}
// // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
// // // //         {posts.map((post) => (
// // // //           <div
// // // //             key={post.id}
// // // //             className="relative group cursor-pointer overflow-hidden"
// // // //             onClick={() => setSelectedPost(post)}
// // // //           >
// // // //             <img
// // // //               src={post.image}
// // // //               alt={post.title}
// // // //               className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //             />
// // // //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// // // //               <FaInstagram className="text-3xl mb-2" />
// // // //               <p className="text-xs md:text-sm font-medium text-center px-2">
// // // //                 {post.title}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {/* === Instagram Post Popup === */}
// // // //       {selectedPost && (
// // // //         <div
// // // //           className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
// // // //           onClick={() => setSelectedPost(null)}
// // // //         >
// // // //           <div
// // // //             onClick={(e) => e.stopPropagation()}
// // // //             className="bg-white w-[90%] md:w-[80%] lg:w-[60%] rounded-xl overflow-hidden flex flex-col shadow-xl animate-fadeIn"
// // // //           >
// // // //             <InstagramEmbed url={selectedPost.url} width="100%" captioned />
// // // //             <button
// // // //               onClick={() => setSelectedPost(null)}
// // // //               className="mt-4 mb-4 mx-auto text-sm bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all"
// // // //             >
// // // //               Close
// // // //             </button>
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </section>
// // // //   );
// // // // };

// // // // export default InstagramGrid;


// // // // import React, { useEffect, useState } from "react";
// // // // import { FaInstagram } from "react-icons/fa";
// // // // import { InstagramEmbed } from "react-social-media-embed";

// // // // const ACCESS_TOKEN = "IGAAeKtZCMOxAZABZAFN0b0F3LU5qVlR0U1NHcU91SXEtZAGdteG5KckxuUm5meWx2ZAURTa3hIT1FPMzRJYmlzUVV3elhXajA3eDc5VktzNUNXaU5uYWxYR2hFSDZA5SGpNc0Rnb191eEIxNHNIcEU1Rk1XWHBQTDJ3WmpqSFpHblllQQZDZD";

// // // // const InstagramGrid = () => {
// // // //   const [posts, setPosts] = useState([]);
// // // //   const [selectedPost, setSelectedPost] = useState(null);

// // // //   useEffect(() => {
// // // //     fetch(
// // // //       `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
// // // //     )
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         if (data.data) setPosts(data.data);
// // // //       })
// // // //       .catch((err) => console.error("Error fetching Instagram feed:", err));
// // // //   }, []);

// // // //   return (
// // // //     <section className="bg-white py-8">
// // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
// // // //         {posts.map((post) => (
// // // //           <div
// // // //             key={post.id}
// // // //             className="relative group cursor-pointer overflow-hidden"
// // // //             onClick={() => setSelectedPost(post)}
// // // //           >
// // // //             <img
// // // //               src={post.media_type === "VIDEO" ? post.thumbnail_url : post.media_url}
// // // //               alt={post.caption}
// // // //               className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //             />
// // // //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// // // //               <FaInstagram className="text-3xl mb-2" />
// // // //               <p className="text-xs md:text-sm font-medium text-center px-2">
// // // //                 {post.caption?.slice(0, 60) || "Instagram Post"}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {selectedPost && (
// // // //         <div
// // // //           className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
// // // //           onClick={() => setSelectedPost(null)}
// // // //         >
// // // //           <div
// // // //             onClick={(e) => e.stopPropagation()}
// // // //             className="bg-white w-[90%] md:w-[80%] lg:w-[60%] rounded-xl overflow-hidden flex flex-col shadow-xl"
// // // //           >
// // // //             <InstagramEmbed url={selectedPost.permalink} width="100%" captioned />
// // // //             <button
// // // //               onClick={() => setSelectedPost(null)}
// // // //               className="mt-4 mb-4 mx-auto text-sm bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all"
// // // //             >
// // // //               Close
// // // //             </button>
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </section>
// // // //   );
// // // // };

// // // // export default InstagramGrid;


// // // // import React, { useEffect, useState } from "react";
// // // // import { FaInstagram } from "react-icons/fa";

// // // // const ACCESS_TOKEN = "IGAAeKtZCMOxAZABZAFN0b0F3LU5qVlR0U1NHcU91SXEtZAGdteG5KckxuUm5meWx2ZAURTa3hIT1FPMzRJYmlzUVV3elhXajA3eDc5VktzNUNXaU5uYWxYR2hFSDZA5SGpNc0Rnb191eEIxNHNIcEU1Rk1XWHBQTDJ3WmpqSFpHblllQQZDZD"; // Replace this

// // // // const InstagramGrid = () => {
// // // //   const [posts, setPosts] = useState([]);
// // // //   const [selectedPost, setSelectedPost] = useState(null);

// // // //   useEffect(() => {
// // // //     const fetchInstagramFeed = async () => {
// // // //       try {
// // // //         const res = await fetch(
// // // //           `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
// // // //         );
// // // //         const data = await res.json();
// // // //         if (data.data) {
// // // //           const sorted = data.data.sort(
// // // //             (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
// // // //           );
// // // //           setPosts(sorted.slice(0, 8)); // show only 8 posts
// // // //         }
// // // //       } catch (err) {
// // // //         console.error("Error fetching Instagram feed:", err);
// // // //       }
// // // //     };

// // // //     fetchInstagramFeed();
// // // //   }, []);

// // // //   return (
// // // //     <section className="bg-white py-8">
// // // //       {/* Grid */}
// // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
// // // //         {posts.map((post) => (
// // // //           <div
// // // //             key={post.id}
// // // //             className="relative group cursor-pointer overflow-hidden"
// // // //             onClick={() => setSelectedPost(post)}
// // // //           >
// // // //             {post.media_type === "VIDEO" ? (
// // // //               <video
// // // //                 src={post.media_url}
// // // //                 muted
// // // //                 playsInline
// // // //                 loop
// // // //                 className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //               />
// // // //             ) : (
// // // //               <img
// // // //                 src={post.media_url}
// // // //                 alt={post.caption}
// // // //                 className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //               />
// // // //             )}
// // // //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// // // //               <FaInstagram className="text-3xl mb-2" />
// // // //               <p className="text-xs md:text-sm font-medium text-center px-2">
// // // //                 {post.caption?.slice(0, 60) || "Instagram Post"}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {/* Popup View */}
// // // //       {selectedPost && (
// // // //         <div
// // // //           className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
// // // //           onClick={() => setSelectedPost(null)}
// // // //         >
// // // //           <div
// // // //             onClick={(e) => e.stopPropagation()}
// // // //             className="bg-white w-[95%] md:w-[80%] lg:w-[70%] rounded-xl overflow-hidden shadow-2xl flex flex-col md:flex-row"
// // // //           >
// // // //             {/* Left side: Media */}
// // // //             <div className="md:w-1/2 w-full bg-black flex items-center justify-center">
// // // //               {selectedPost.media_type === "VIDEO" ? (
// // // //                 <video
// // // //                   src={selectedPost.media_url}
// // // //                   controls
// // // //                   autoPlay
// // // //                   playsInline
// // // //                   className="w-full h-full object-cover"
// // // //                 />
// // // //               ) : (
// // // //                 <img
// // // //                   src={selectedPost.media_url}
// // // //                   alt={selectedPost.caption}
// // // //                   className="w-full h-full object-cover"
// // // //                 />
// // // //               )}
// // // //             </div>

// // // //             {/* Right side: Caption */}
// // // //             <div className="md:w-1/2 w-full p-6 flex flex-col justify-between text-gray-900">
// // // //               <div>
// // // //                 <div className="flex items-center gap-2 mb-3">
// // // //                   <FaInstagram className="text-xl text-pink-600" />
// // // //                   <p className="font-semibold">@bakelore.in</p>
// // // //                 </div>
// // // //                 <p className="text-sm md:text-base leading-relaxed whitespace-pre-line">
// // // //                   {selectedPost.caption || "Instagram Post"}
// // // //                 </p>
// // // //               </div>

// // // //               <div className="flex justify-end mt-6">
// // // //                 <button
// // // //                   onClick={() => setSelectedPost(null)}
// // // //                   className="text-sm bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all"
// // // //                 >
// // // //                   Close
// // // //                 </button>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </section>
// // // //   );
// // // // };

// // // // export default InstagramGrid;



// // // // import React, { useEffect, useState } from "react";
// // // // import { FaInstagram } from "react-icons/fa";
// // // // import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// // // // const ACCESS_TOKEN = "IGAAeKtZCMOxAZABZAFN0b0F3LU5qVlR0U1NHcU91SXEtZAGdteG5KckxuUm5meWx2ZAURTa3hIT1FPMzRJYmlzUVV3elhXajA3eDc5VktzNUNXaU5uYWxYR2hFSDZA5SGpNc0Rnb191eEIxNHNIcEU1Rk1XWHBQTDJ3WmpqSFpHblllQQZDZD"; // Replace this

// // // // const InstagramGrid = () => {
// // // //   const [posts, setPosts] = useState([]);
// // // //   const [selectedIndex, setSelectedIndex] = useState(null);

// // // //   // Fetch Instagram posts
// // // //   useEffect(() => {
// // // //     const fetchInstagramFeed = async () => {
// // // //       try {
// // // //         const res = await fetch(
// // // //           `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
// // // //         );
// // // //         const data = await res.json();
// // // //         if (data.data) {
// // // //           const sorted = data.data.sort(
// // // //             (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
// // // //           );
// // // //           setPosts(sorted.slice(0, 8)); // show only 8 latest
// // // //         }
// // // //       } catch (err) {
// // // //         console.error("Error fetching Instagram feed:", err);
// // // //       }
// // // //     };

// // // //     fetchInstagramFeed();
// // // //   }, []);

// // // //   const selectedPost = selectedIndex !== null ? posts[selectedIndex] : null;

// // // //   const handleNext = (e) => {
// // // //     e.stopPropagation();
// // // //     if (posts.length > 0) {
// // // //       setSelectedIndex((prev) => (prev + 1) % posts.length);
// // // //     }
// // // //   };

// // // //   const handlePrev = (e) => {
// // // //     e.stopPropagation();
// // // //     if (posts.length > 0) {
// // // //       setSelectedIndex((prev) => (prev - 1 + posts.length) % posts.length);
// // // //     }
// // // //   };

// // // //   return (
// // // //     <section className="bg-white py-8">
// // // //       {/* Grid */}
// // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
// // // //         {posts.map((post, index) => (
// // // //           <div
// // // //             key={post.id}
// // // //             className="relative group cursor-pointer overflow-hidden"
// // // //             onClick={() => setSelectedIndex(index)}
// // // //           >
// // // //             {post.media_type === "VIDEO" ? (
// // // //               <video
// // // //                 src={post.media_url}
// // // //                 muted
// // // //                 playsInline
// // // //                 loop
// // // //                 className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //               />
// // // //             ) : (
// // // //               <img
// // // //                 src={post.media_url}
// // // //                 alt={post.caption}
// // // //                 className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //               />
// // // //             )}
// // // //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// // // //               <FaInstagram className="text-3xl mb-2" />
// // // //               <p className="text-xs md:text-sm font-medium text-center px-2">
// // // //                 {post.caption?.slice(0, 60) || "Instagram Post"}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {/* Popup View */}
// // // //       {selectedPost && (
// // // //         <div
// // // //           className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 px-2"
// // // //           onClick={() => setSelectedIndex(null)}
// // // //         >
// // // //           <div
// // // //             onClick={(e) => e.stopPropagation()}
// // // //             className="relative bg-white w-full max-w-5xl rounded-xl overflow-hidden shadow-2xl flex flex-col md:flex-row max-h-[90vh] transition-all duration-500"
// // // //           >
// // // //             {/* Left: Media */}
// // // //             <div className="md:w-1/2 w-full bg-black flex items-center justify-center p-2">
// // // //               {selectedPost.media_type === "VIDEO" ? (
// // // //                 <video
// // // //                   src={selectedPost.media_url}
// // // //                   controls
// // // //                   autoPlay
// // // //                   playsInline
// // // //                   className="max-h-[80vh] w-full object-contain rounded-lg"
// // // //                 />
// // // //               ) : (
// // // //                 <img
// // // //                   src={selectedPost.media_url}
// // // //                   alt={selectedPost.caption}
// // // //                   className="max-h-[80vh] w-full object-contain rounded-lg"
// // // //                 />
// // // //               )}
// // // //             </div>

// // // //             {/* Right: Caption */}
// // // //             <div className="md:w-1/2 w-full p-6 flex flex-col justify-between text-gray-900 overflow-y-auto max-h-[90vh]">
// // // //               <div>
// // // //                 <div className="flex items-center gap-2 mb-3">
// // // //                   <FaInstagram className="text-xl text-pink-600" />
// // // //                   <p className="font-semibold">@bakelore.in</p>
// // // //                 </div>
// // // //                 <p className="text-sm md:text-base leading-relaxed whitespace-pre-line">
// // // //                   {selectedPost.caption || "Instagram Post"}
// // // //                 </p>
// // // //               </div>

// // // //               <div className="flex justify-end mt-6">
// // // //                 <button
// // // //                   onClick={() => setSelectedIndex(null)}
// // // //                   className="text-sm bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all"
// // // //                 >
// // // //                   Close
// // // //                 </button>
// // // //               </div>
// // // //             </div>

// // // //             {/* Navigation Arrows */}
// // // //             {posts.length > 1 && (
// // // //               <>
// // // //                 <button
// // // //                   onClick={handlePrev}
// // // //                   className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full text-xl"
// // // //                 >
// // // //                   <IoIosArrowBack />
// // // //                 </button>
// // // //                 <button
// // // //                   onClick={handleNext}
// // // //                   className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full text-xl"
// // // //                 >
// // // //                   <IoIosArrowForward />
// // // //                 </button>
// // // //               </>
// // // //             )}
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </section>
// // // //   );
// // // // };

// // // // export default InstagramGrid;


// // // // import React, { useEffect, useState } from "react";
// // // // import { FaInstagram } from "react-icons/fa";
// // // // import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// // // // const ACCESS_TOKEN = "IGAAeKtZCMOxAZABZAFN0b0F3LU5qVlR0U1NHcU91SXEtZAGdteG5KckxuUm5meWx2ZAURTa3hIT1FPMzRJYmlzUVV3elhXajA3eDc5VktzNUNXaU5uYWxYR2hFSDZA5SGpNc0Rnb191eEIxNHNIcEU1Rk1XWHBQTDJ3WmpqSFpHblllQQZDZD"; // your valid token

// // // // const InstagramGrid = () => {
// // // //   const [posts, setPosts] = useState([]);
// // // //   const [selectedIndex, setSelectedIndex] = useState(null);

// // // //   useEffect(() => {
// // // //     fetch(
// // // //       `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
// // // //     )
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         if (data.data) setPosts(data.data.slice(0, 8)); // show only 8 posts
// // // //       })
// // // //       .catch((err) => console.error("Error fetching Instagram feed:", err));
// // // //   }, []);

// // // //   const selectedPost = selectedIndex !== null ? posts[selectedIndex] : null;

// // // //   const nextPost = (e) => {
// // // //     e.stopPropagation();
// // // //     setSelectedIndex((prev) => (prev + 1) % posts.length);
// // // //   };

// // // //   const prevPost = (e) => {
// // // //     e.stopPropagation();
// // // //     setSelectedIndex((prev) => (prev - 1 + posts.length) % posts.length);
// // // //   };

// // // //   return (
// // // //     <section className="bg-white py-8">
// // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
// // // //         {posts.map((post, index) => (
// // // //           <div
// // // //             key={post.id}
// // // //             className="relative group cursor-pointer overflow-hidden"
// // // //             onClick={() => setSelectedIndex(index)}
// // // //           >
// // // //             <img
// // // //               src={post.media_type === "VIDEO" ? post.thumbnail_url : post.media_url}
// // // //               alt={post.caption}
// // // //               className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //             />
// // // //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// // // //               <FaInstagram className="text-3xl mb-2" />
// // // //               <p className="text-xs md:text-sm font-medium text-center px-2">
// // // //                 {post.caption?.slice(0, 60) || "Instagram Post"}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {selectedPost && (
// // // //         <div
// // // //           className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
// // // //           onClick={() => setSelectedIndex(null)}
// // // //         >
// // // //           <div
// // // //             onClick={(e) => e.stopPropagation()}
// // // //             className="relative bg-white w-[95%] md:w-[80%] lg:w-[70%] rounded-xl overflow-hidden flex flex-col md:flex-row shadow-xl"
// // // //           >
// // // //             <div className="relative flex-1 bg-black flex items-center justify-center">
// // // //               {selectedPost.media_type === "VIDEO" ? (
// // // //                 <video
// // // //                   src={selectedPost.media_url}
// // // //                   controls
// // // //                   autoPlay
// // // //                   className="w-full h-full object-cover"
// // // //                 />
// // // //               ) : (
// // // //                 <img
// // // //                   src={selectedPost.media_url}
// // // //                   alt={selectedPost.caption}
// // // //                   className="w-full h-full object-cover"
// // // //                 />
// // // //               )}

// // // //               {/* Left arrow */}
// // // //               <button
// // // //                 onClick={prevPost}
// // // //                 className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black text-white p-2 rounded-full"
// // // //               >
// // // //                 <IoIosArrowBack size={22} />
// // // //               </button>

// // // //               {/* Right arrow */}
// // // //               <button
// // // //                 onClick={nextPost}
// // // //                 className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black text-white p-2 rounded-full"
// // // //               >
// // // //                 <IoIosArrowForward size={22} />
// // // //               </button>
// // // //             </div>

// // // //             <div className="p-6 flex flex-col justify-between w-full md:w-1/2">
// // // //               <div>
// // // //                 <h2 className="text-lg font-semibold text-gray-800 mb-2">
// // // //                   <FaInstagram className="inline-block mr-2 text-pink-600" />
// // // //                   {selectedPost.caption?.split(" ")[0] || "@bakelore.in"}
// // // //                 </h2>
// // // //                 <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">
// // // //                   {selectedPost.caption || "Instagram post"}
// // // //                 </p>
// // // //               </div>
// // // //               <button
// // // //                 onClick={() => setSelectedIndex(null)}
// // // //                 className="mt-6 self-end bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all"
// // // //               >
// // // //                 Close
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </section>
// // // //   );
// // // // };

// // // // export default InstagramGrid;


// // // // import React, { useEffect, useState } from "react";
// // // // import { FaInstagram } from "react-icons/fa";
// // // // import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// // // // const ACCESS_TOKEN = "IGAAeKtZCMOxAZABZAFN0b0F3LU5qVlR0U1NHcU91SXEtZAGdteG5KckxuUm5meWx2ZAURTa3hIT1FPMzRJYmlzUVV3elhXajA3eDc5VktzNUNXaU5uYWxYR2hFSDZA5SGpNc0Rnb191eEIxNHNIcEU1Rk1XWHBQTDJ3WmpqSFpHblllQQZDZD"; // your valid Instagram access token

// // // // const InstagramGrid = () => {
// // // //   const [posts, setPosts] = useState([]);
// // // //   const [selectedIndex, setSelectedIndex] = useState(null);

// // // //   useEffect(() => {
// // // //     fetch(
// // // //       `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
// // // //     )
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         if (data.data) setPosts(data.data.slice(0, 8)); // show only 8 posts
// // // //       })
// // // //       .catch((err) => console.error("Error fetching Instagram feed:", err));
// // // //   }, []);

// // // //   const selectedPost = selectedIndex !== null ? posts[selectedIndex] : null;

// // // //   const nextPost = (e) => {
// // // //     e.stopPropagation();
// // // //     setSelectedIndex((prev) => (prev + 1) % posts.length);
// // // //   };

// // // //   const prevPost = (e) => {
// // // //     e.stopPropagation();
// // // //     setSelectedIndex((prev) => (prev - 1 + posts.length) % posts.length);
// // // //   };

// // // //   return (
// // // //     <section className="bg-white py-8">
// // // //       {/* Grid layout */}
// // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
// // // //         {posts.map((post, index) => (
// // // //           <div
// // // //             key={post.id}
// // // //             className="relative group cursor-pointer overflow-hidden"
// // // //             onClick={() => setSelectedIndex(index)}
// // // //           >
// // // //             <img
// // // //               src={post.media_type === "VIDEO" ? post.thumbnail_url : post.media_url}
// // // //               alt={post.caption}
// // // //               className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //             />
// // // //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// // // //               <FaInstagram className="text-3xl mb-2" />
// // // //               <p className="text-xs md:text-sm font-medium text-center px-2">
// // // //                 {post.caption?.slice(0, 60) || "Instagram Post"}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {/* Popup Modal */}
// // // //       {selectedPost && (
// // // //         <div
// // // //           className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
// // // //           onClick={() => setSelectedIndex(null)}
// // // //         >
// // // //           <div
// // // //             onClick={(e) => e.stopPropagation()}
// // // //             className="relative bg-white w-[95%] md:w-[80%] lg:w-[70%] h-[700px] rounded-xl overflow-hidden flex flex-col md:flex-row shadow-xl"
// // // //           >
// // // //             {/* Media Section */}
// // // //             <div className="relative flex-1 bg-black flex items-center justify-center h-full">
// // // //               {selectedPost.media_type === "VIDEO" ? (
// // // //                 <video
// // // //                   src={selectedPost.media_url}
// // // //                   controls
// // // //                   autoPlay
// // // //                   muted
// // // //                   className="w-full h-full object-cover"
// // // //                 />
// // // //               ) : (
// // // //                 <img
// // // //                   src={selectedPost.media_url}
// // // //                   alt={selectedPost.caption}
// // // //                   className="w-full h-full object-cover"
// // // //                 />
// // // //               )}

// // // //               {/* Left arrow */}
// // // //               <button
// // // //                 onClick={prevPost}
// // // //                 className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black text-white p-2 rounded-full"
// // // //               >
// // // //                 <IoIosArrowBack size={22} />
// // // //               </button>

// // // //               {/* Right arrow */}
// // // //               <button
// // // //                 onClick={nextPost}
// // // //                 className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black text-white p-2 rounded-full"
// // // //               >
// // // //                 <IoIosArrowForward size={22} />
// // // //               </button>
// // // //             </div>

// // // //             {/* Caption Section */}
// // // //             <div className="p-6 flex flex-col justify-between w-full md:w-1/2 h-full overflow-y-auto">
// // // //               <div>
// // // //                 <h2 className="text-lg font-semibold text-gray-800 mb-2">
// // // //                   <FaInstagram className="inline-block mr-2 text-pink-600" />
// // // //                   @bakelore.in
// // // //                 </h2>
// // // //                 <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">
// // // //                   {selectedPost.caption || "Instagram post"}
// // // //                 </p>
// // // //               </div>
// // // //               <button
// // // //                 onClick={() => setSelectedIndex(null)}
// // // //                 className="mt-6 self-end bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all"
// // // //               >
// // // //                 Close
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </section>
// // // //   );
// // // // };

// // // // export default InstagramGrid;------------->>>>>>>>>>>>>>>>>>>>



// // // // import React, { useEffect, useState } from "react";
// // // // import { FaInstagram } from "react-icons/fa";
// // // // import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// // // // const ACCESS_TOKEN = ""; // your Instagram access token

// // // // const InstagramGrid = () => {
// // // //   const [posts, setPosts] = useState([]);
// // // //   const [selectedIndex, setSelectedIndex] = useState(null);

// // // //   useEffect(() => {
// // // //     fetch(
// // // //       `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
// // // //     )
// // // //       .then((res) => res.json())
// // // //       .then((data) => {
// // // //         if (data.data) setPosts(data.data.slice(0, 8)); // show 8 posts
// // // //       })
// // // //       .catch((err) => console.error("Error fetching Instagram feed:", err));
// // // //   }, []);

// // // //   const selectedPost = selectedIndex !== null ? posts[selectedIndex] : null;

// // // //   const nextPost = (e) => {
// // // //     e.stopPropagation();
// // // //     setSelectedIndex((prev) => (prev + 1) % posts.length);
// // // //   };

// // // //   const prevPost = (e) => {
// // // //     e.stopPropagation();
// // // //     setSelectedIndex((prev) => (prev - 1 + posts.length) % posts.length);
// // // //   };

// // // //   return (
// // // //     <section className="bg-white py-8">
// // // //       <h2 className="text-center text-2xl md:text-3xl font-semibold text-gray-800 mb-8">
// // // //         Follow us on <span className="text-pink-600">Instagram</span>
// // // //       </h2>
// // // //       {/* Grid layout */}
// // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
// // // //         {posts.map((post, index) => (
// // // //           <div
// // // //             key={post.id}
// // // //             className="relative group cursor-pointer overflow-hidden"
// // // //             onClick={() => setSelectedIndex(index)}
// // // //           >
// // // //             <img
// // // //               src={post.media_type === "VIDEO" ? post.thumbnail_url : post.media_url}
// // // //               alt={post.caption}
// // // //               className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //             />
// // // //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// // // //               <FaInstagram className="text-3xl mb-2" />
// // // //               <p className="text-xs md:text-sm font-medium text-center px-2">
// // // //                 {post.caption?.slice(0, 60) || "Instagram Post"}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {/* Popup */}
// // // //       {selectedPost && (
// // // //         <div
// // // //           className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-3 md:p-6"
// // // //           onClick={() => setSelectedIndex(null)}
// // // //         >
// // // //           <div
// // // //             onClick={(e) => e.stopPropagation()}
// // // //             className="relative bg-white w-full max-w-[1000px] h-auto md:h-[700px] rounded-xl overflow-hidden flex flex-col md:flex-row shadow-xl"
// // // //           >
// // // //             {/* Media Section */}
// // // //             <div className="relative w-full md:w-1/2 h-[300px] md:h-full bg-black flex items-center justify-center">
// // // //               {selectedPost.media_type === "VIDEO" ? (
// // // //                 <video
// // // //                   src={selectedPost.media_url}
// // // //                   controls
// // // //                   autoPlay
// // // //                   muted
// // // //                   className="w-full h-full object-cover"
// // // //                 />
// // // //               ) : (
// // // //                 <img
// // // //                   src={selectedPost.media_url}
// // // //                   alt={selectedPost.caption}
// // // //                   className="w-full h-full object-cover"
// // // //                 />
// // // //               )}

// // // //               {/* Left arrow */}
// // // //               <button
// // // //                 onClick={prevPost}
// // // //                 className="absolute left-2 md:left-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black text-white p-2 rounded-full"
// // // //               >
// // // //                 <IoIosArrowBack size={20} />
// // // //               </button>

// // // //               {/* Right arrow */}
// // // //               <button
// // // //                 onClick={nextPost}
// // // //                 className="absolute right-2 md:right-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black text-white p-2 rounded-full"
// // // //               >
// // // //                 <IoIosArrowForward size={20} />
// // // //               </button>
// // // //             </div>

// // // //             {/* Caption Section */}
// // // //             <div className="p-5 md:p-6 flex flex-col justify-between w-full md:w-1/2 h-auto md:h-full overflow-y-auto">
// // // //               <div>
// // // //                 <h2 className="text-lg font-semibold text-gray-800 mb-2">
// // // //                   <FaInstagram className="inline-block mr-2 text-pink-600" />
// // // //                   @bakelore.in
// // // //                 </h2>
// // // //                 <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">
// // // //                   {selectedPost.caption || "Instagram post"}
// // // //                 </p>
// // // //               </div>
// // // //               <button
// // // //                 onClick={() => setSelectedIndex(null)}
// // // //                 className="mt-6 self-end bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all"
// // // //               >
// // // //                 Close
// // // //               </button>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </section>
// // // //   );
// // // // };

// // // // export default InstagramGrid;


// // // import React, { useEffect, useState } from "react";
// // // import { FaInstagram } from "react-icons/fa";
// // // import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// // // const ACCESS_TOKEN = "IGAAeKtZCMOxAZABZAFN0b0F3LU5qVlR0U1NHcU91SXEtZAGdteG5KckxuUm5meWx2ZAURTa3hIT1FPMzRJYmlzUVV3elhXajA3eDc5VktzNUNXaU5uYWxYR2hFSDZA5SGpNc0Rnb191eEIxNHNIcEU1Rk1XWHBQTDJ3WmpqSFpHblllQQZDZD"; // Add your Instagram access token here

// // // const InstagramGrid = () => {
// // //   const [posts, setPosts] = useState([]);
// // //   const [selectedIndex, setSelectedIndex] = useState(null);

// // //   useEffect(() => {
// // //     fetch(
// // //       `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
// // //     )
// // //       .then((res) => res.json())
// // //       .then((data) => {
// // //         if (data.data) setPosts(data.data.slice(0, 8)); // Limit to 8 posts
// // //       })
// // //       .catch((err) => console.error("Error fetching Instagram feed:", err));
// // //   }, []);

// // //   const selectedPost = selectedIndex !== null ? posts[selectedIndex] : null;

// // //   const nextPost = (e) => {
// // //     e.stopPropagation();
// // //     setSelectedIndex((prev) => (prev + 1) % posts.length);
// // //   };

// // //   const prevPost = (e) => {
// // //     e.stopPropagation();
// // //     setSelectedIndex((prev) => (prev - 1 + posts.length) % posts.length);
// // //   };

// // //   return (
// // //     <section className="bg-white py-8">
// // //       {/* Heading */}
// // //       <h2
// // //         className="text-center text-2xl md:text-3xl font-semibold mb-8"
// // //         style={{ fontFamily: "Philosopher", serif", color: "#2b2b2b" }}
// // //       >
// // //         Follow us on <span className="text-[#C08B89]">Instagram</span>

// // //       </h2>

// // //       {/* Grid */}
// // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
// // //         {posts.map((post, index) => (
// // //           <div
// // //             key={post.id}
// // //             className="relative group cursor-pointer overflow-hidden"
// // //             onClick={() => setSelectedIndex(index)}
// // //           >
// // //             <img
// // //               src={post.media_type === "VIDEO" ? post.thumbnail_url : post.media_url}
// // //               alt={post.caption || "Instagram Post"}
// // //               className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // //             />
// // //             {/* Hover overlay */}
// // //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// // //               <FaInstagram className="text-3xl mb-2" />
// // //               <p
// // //                 className="text-xs md:text-sm font-medium text-center px-2"
// // //                 style={{ fontFamily: "Manrope, sans-serif" }}
// // //               >
// // //                 {post.caption?.slice(0, 60) || "Instagram Post"}
// // //               </p>
// // //             </div>
// // //           </div>
// // //         ))}
// // //       </div>

// // //       {/* Popup */}
// // //       {selectedPost && (
// // //         <div
// // //           className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-3 md:p-6"
// // //           onClick={() => setSelectedIndex(null)}
// // //         >
// // //           <div
// // //             onClick={(e) => e.stopPropagation()}
// // //             className="relative bg-white w-full max-w-[1000px] h-[700px] rounded-xl overflow-hidden flex flex-col md:flex-row shadow-xl"
// // //           >
// // //             {/* Media section */}
// // //             <div className="relative w-full md:w-1/2 h-full bg-black flex items-center justify-center overflow-hidden">
// // //               {selectedPost.media_type === "VIDEO" ? (
// // //                 <video
// // //                   src={selectedPost.media_url}
// // //                   controls
// // //                   autoPlay
// // //                   muted
// // //                   className="w-full h-full object-cover transform transition-transform duration-500 hover:scale-105"
// // //                 />
// // //               ) : (
// // //                 <img
// // //                   src={selectedPost.media_url}
// // //                   alt={selectedPost.caption || "Instagram post"}
// // //                   className="w-full h-full object-cover transform transition-transform duration-500 hover:scale-105"
// // //                 />
// // //               )}

// // //               {/* Navigation arrows */}
// // //               <button
// // //                 onClick={prevPost}
// // //                 className="absolute left-2 md:left-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black text-white p-2 rounded-full"
// // //               >
// // //                 <IoIosArrowBack size={20} />
// // //               </button>
// // //               <button
// // //                 onClick={nextPost}
// // //                 className="absolute right-2 md:right-3 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black text-white p-2 rounded-full"
// // //               >
// // //                 <IoIosArrowForward size={20} />
// // //               </button>
// // //             </div>

// // //             {/* Caption section */}
// // //             <div className="p-5 md:p-6 flex flex-col justify-between w-full md:w-1/2 h-full overflow-y-auto">
// // //               <div>
// // //                 <h2
// // //                   className="text-lg font-semibold mb-2"
// // //                   style={{ fontFamily: "Philosopher", serif", color: "#2b2b2b" }}
// // //                 >
// // //                   <FaInstagram className="inline-block mr-2 text-pink-600" />
// // //                   @bakelore.in
// // //                 </h2>
// // //                 <p
// // //                   className="text-gray-700 text-sm leading-relaxed whitespace-pre-line"
// // //                   style={{ fontFamily: "Manrope, sans-serif" }}
// // //                 >
// // //                   {selectedPost.caption || "Instagram post"}
// // //                 </p>
// // //               </div>
// // //               <button
// // //                 onClick={() => setSelectedIndex(null)}
// // //                 className="mt-6 self-end bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all"
// // //                 style={{ fontFamily: "Manrope, sans-serif" }}
// // //               >
// // //                 Close
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}
// // //     </section>
// // //   );
// // // };

// // // export default InstagramGrid;



// // // // import React, { useEffect, useState } from "react";
// // // // import { FaInstagram } from "react-icons/fa";

// // // // const ACCESS_TOKEN = "IGAAeKtZCMOxAZABZAFN0b0F3LU5qVlR0U1NHcU91SXEtZAGdteG5KckxuUm5meWx2ZAURTa3hIT1FPMzRJYmlzUVV3elhXajA3eDc5VktzNUNXaU5uYWxYR2hFSDZA5SGpNc0Rnb191eEIxNHNIcEU1Rk1XWHBQTDJ3WmpqSFpHblllQQZDZD"; // Replace this

// // // // const InstagramGrid = () => {
// // // //   const [posts, setPosts] = useState([]);
// // // //   const [selectedPost, setSelectedPost] = useState(null);

// // // //   useEffect(() => {
// // // //     const fetchInstagramFeed = async () => {
// // // //       try {
// // // //         const res = await fetch(
// // // //           `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
// // // //         );
// // // //         const data = await res.json();
// // // //         if (data.data) {
// // // //           const sorted = data.data.sort(
// // // //             (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
// // // //           );
// // // //           setPosts(sorted.slice(0, 8)); // show only 8 posts
// // // //         }
// // // //       } catch (err) {
// // // //         console.error("Error fetching Instagram feed:", err);
// // // //       }
// // // //     };

// // // //     fetchInstagramFeed();
// // // //   }, []);

// // // //   return (
// // // //     <section className="bg-white py-8">
// // // //       {/* Grid */}
// // // //       <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
// // // //         {posts.map((post) => (
// // // //           <div
// // // //             key={post.id}
// // // //             className="relative group cursor-pointer overflow-hidden"
// // // //             onClick={() => setSelectedPost(post)}
// // // //           >
// // // //             {post.media_type === "VIDEO" ? (
// // // //               <video
// // // //                 src={post.media_url}
// // // //                 muted
// // // //                 playsInline
// // // //                 loop
// // // //                 className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //               />
// // // //             ) : (
// // // //               <img
// // // //                 src={post.media_url}
// // // //                 alt={post.caption}
// // // //                 className="w-full h-60 object-cover transform transition-transform duration-500 group-hover:scale-105"
// // // //               />
// // // //             )}
// // // //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// // // //               <FaInstagram className="text-3xl mb-2" />
// // // //               <p className="text-xs md:text-sm font-medium text-center px-2">
// // // //                 {post.caption?.slice(0, 60) || "Instagram Post"}
// // // //               </p>
// // // //             </div>
// // // //           </div>
// // // //         ))}
// // // //       </div>

// // // //       {/* Popup View */}
// // // //       {selectedPost && (
// // // //         <div
// // // //           className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 px-2"
// // // //           onClick={() => setSelectedPost(null)}
// // // //         >
// // // //           <div
// // // //             onClick={(e) => e.stopPropagation()}
// // // //             className="bg-white w-full max-w-5xl rounded-xl overflow-hidden shadow-2xl flex flex-col md:flex-row max-h-[90vh]"
// // // //           >
// // // //             {/* Left side: Media */}
// // // //             <div className="md:w-1/2 w-full bg-black flex items-center justify-center p-2">
// // // //               {selectedPost.media_type === "VIDEO" ? (
// // // //                 <video
// // // //                   src={selectedPost.media_url}
// // // //                   controls
// // // //                   autoPlay
// // // //                   playsInline
// // // //                   className="max-h-[90vh] w-auto object-cover rounded-lg"
// // // //                 />
// // // //               ) : (
// // // //                 <img
// // // //                   src={selectedPost.media_url}
// // // //                   alt={selectedPost.caption}
// // // //                   className="max-h-[80vh] w-auto object-contain rounded-lg"
// // // //                 />
// // // //               )}
// // // //             </div>

// // // //             {/* Right side: Caption */}
// // // //             <div className="md:w-1/2 w-full p-6 flex flex-col justify-between text-gray-900 overflow-y-auto max-h-[90vh]">
// // // //               <div>
// // // //                 <div className="flex items-center gap-2 mb-3">
// // // //                   <FaInstagram className="text-xl text-pink-600" />
// // // //                   <p className="font-semibold">@bakelore.in</p>
// // // //                 </div>
// // // //                 <p className="text-sm md:text-base leading-relaxed whitespace-pre-line">
// // // //                   {selectedPost.caption || "Instagram Post"}
// // // //                 </p>
// // // //               </div>

// // // //               <div className="flex justify-end mt-6">
// // // //                 <button
// // // //                   onClick={() => setSelectedPost(null)}
// // // //                   className="text-sm bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-all"
// // // //                 >
// // // //                   Close
// // // //                 </button>
// // // //               </div>
// // // //             </div>
// // // //           </div>
// // // //         </div>
// // // //       )}
// // // //     </section>
// // // //   );
// // // // };

// // // // export default InstagramGrid;


// // // // import React, { useEffect, useState } from "react";

// // // // const InstagramFeed = () => {
// // // //   const [posts, setPosts] = useState([]);

// // // //   useEffect(() => {
// // // //     const token = "YOUR_LONG_LIVED_ACCESS_TOKEN";
// // // //     fetch(`https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,timestamp&access_token=${token}`)
// // // //       .then(res => res.json())
// // // //       .then(data => setPosts(data.data || []));
// // // //   }, []);

// // // //   return (
// // // //     <div className="grid grid-cols-3 gap-4">
// // // //       {posts.map(post => (
// // // //         <a key={post.id} href={post.permalink} target="_blank" rel="noreferrer">
// // // //           <img src={post.media_url} alt={post.caption} className="w-full rounded-lg"/>
// // // //         </a>
// // // //       ))}
// // // //     </div>
// // // //   );
// // // // };

// // // // export default InstagramFeed;



// // import React, { useEffect, useState } from "react";
// // import { FaInstagram } from "react-icons/fa";
// // import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// // const ACCESS_TOKEN =
//   // "IGAAeKtZCMOxAZABZAFlvNUxfcjllTk  RHbzJkM09qTlFwQncxa2J1TTR4Xy1JekxPd05BekdZARmhPWmlyOUVaNGRubnpGd1ZAKdE5KTU1sbndLTUFQLVhPT3kzcDgzZAnMxNUdpQ1hIYVVvX3U5VXV4U3VlQ3dzWnhVU1RyZAThRYlkzNAZDZD";

// // const InstagramGrid = () => {
// //   const [posts, setPosts] = useState([]);
// //   const [selectedIndex, setSelectedIndex] = useState(null);

// //   useEffect(() => {
// //     fetch(
// //       `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
// //     )
// //       .then((res) => res.json())
// //       .then((data) => {
// //         if (data?.data) setPosts(data.data.slice(0, 8));
// //       })
// //       .catch((err) =>
// //         console.error("Error fetching Instagram feed:", err)
// //       );
// //   }, []);

// //   const selectedPost =
// //     selectedIndex !== null ? posts[selectedIndex] : null;

// //   const nextPost = (e) => {
// //     e.stopPropagation();
// //     setSelectedIndex((prev) => (prev + 1) % posts.length);
// //   };

// //   const prevPost = (e) => {
// //     e.stopPropagation();
// //     setSelectedIndex((prev) => (prev - 1 + posts.length) % posts.length);
// //   };

// //   return (
// //     <section className="bg-white py-8">
// //       {/* Heading */}
// //       <h2
// //         className="text-center text-2xl md:text-3xl font-semibold mb-8"
// //         style={{ fontFamily: "Philosopher", serif", color: "#2b2b2b" }}
// //       >
// //         Follow us on <span className="text-[#C08B89]">Instagram</span>
// //       </h2>

// //       {/* GRID – 3 columns on mobile */}
// //       <div className="grid grid-cols-3 md:grid-cols-4 gap-[2px] px-2 md:px-4">
// //         {posts.map((post, index) => (
// //           <div
// //             key={post.id}
// //             className="relative group cursor-pointer overflow-hidden"
// //             onClick={() => setSelectedIndex(index)}
// //           >
// //             <img
// //               src={
// //                 post.media_type === "VIDEO"
// //                   ? post.thumbnail_url
// //                   : post.media_url
// //               }
// //               alt={post.caption || "Instagram Post"}
// //               className="w-full h-32 sm:h-44 md:h-60 object-cover transition-transform duration-500 group-hover:scale-105"
// //             />

// //             {/* Hover Overlay */}
// //             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
// //               <FaInstagram className="text-3xl mb-2" />
// //               <p className="text-xs text-center px-2 line-clamp-2">
// //                 {post.caption || "Instagram Post"}
// //               </p>
// //             </div>
// //           </div>
// //         ))}
// //       </div>

// //       {/* POPUP */}
// //       {selectedPost && (
// //         <div
// //           className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-3 md:p-6"
// //           onClick={() => setSelectedIndex(null)}
// //         >
// //           <div
// //             onClick={(e) => e.stopPropagation()}
// //             className="relative bg-white w-full max-w-[1000px] h-[80vh] rounded-xl overflow-hidden flex flex-col md:flex-row"
// //           >
// //             {/* Media */}
// //             <div className="relative w-full md:w-1/2 bg-black flex items-center justify-center">
// //               {selectedPost.media_type === "VIDEO" ? (
// //                 <video
// //                   src={selectedPost.media_url}
// //                   controls
// //                   autoPlay
// //                   muted
// //                   className="w-full h-full object-cover"
// //                 />
// //               ) : (
// //                 <img
// //                   src={selectedPost.media_url}
// //                   alt="Instagram post"
// //                   className="w-full h-full object-cover"
// //                 />
// //               )}

// //               {/* Arrows */}
// //               <button
// //                 onClick={prevPost}
// //                 className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/60 text-white p-2 rounded-full"
// //               >
// //                 <IoIosArrowBack size={22} />
// //               </button>
// //               <button
// //                 onClick={nextPost}
// //                 className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/60 text-white p-2 rounded-full"
// //               >
// //                 <IoIosArrowForward size={22} />
// //               </button>
// //             </div>

// //             {/* Caption */}
// //             <div className="p-5 flex flex-col justify-between md:w-1/2 overflow-y-auto">
// //               <div>
// //                 <h3 className="font-semibold text-lg mb-3">
// //                   <FaInstagram className="inline mr-2 text-pink-600" />
// //                   @bakelore.in
// //                 </h3>
// //                 <p className="text-sm text-gray-700 whitespace-pre-line">
// //                   {selectedPost.caption || "Instagram post"}
// //                 </p>
// //               </div>

// //               <button
// //                 onClick={() => setSelectedIndex(null)}
// //                 className="mt-6 self-end bg-black text-white px-5 py-2 rounded-lg"
// //               >
// //                 Close
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </section>
// //   );
// // };

// // export default InstagramGrid;



// import React, { useEffect, useState } from "react";
// import { FaInstagram } from "react-icons/fa";
// import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

// const ACCESS_TOKEN =
//   "IGAAeKtZCMOxAZABZAFlvNUxfcjllTk  RHbzJkM09qTlFwQncxa2J1TTR4Xy1JekxPd05BekdZARmhPWmlyOUVaNGRubnpGd1ZAKdE5KTU1sbndLTUFQLVhPT3kzcDgzZAnMxNUdpQ1hIYVVvX3U5VXV4U3VlQ3dzWnhVU1RyZAThRYlkzNAZDZD";

// const InstagramGrid = () => {
//   const [posts, setPosts] = useState([]);
//   const [selectedIndex, setSelectedIndex] = useState(null);

//   useEffect(() => {
//     fetch(
//       `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         if (data.data) setPosts(data.data.slice(0, 8));
//       })
//       .catch((err) => console.error("Error fetching Instagram feed:", err));
//   }, []);

//   const selectedPost = selectedIndex !== null ? posts[selectedIndex] : null;

//   const nextPost = (e) => {
//     e.stopPropagation();
//     setSelectedIndex((prev) => (prev + 1) % posts.length);
//   };

//   const prevPost = (e) => {
//     e.stopPropagation();
//     setSelectedIndex((prev) => (prev - 1 + posts.length) % posts.length);
//   };

//   return (
//     <section className="bg-white py-8">
//       {/* Heading */}
//       <h2
//         className="text-center text-2xl md:text-3xl font-semibold mb-8"
//         style={{ fontFamily: "Philosopher", serif", color: "#2b2b2b" }}
//       >
//         Follow us on <span className="text-[#C08B89]">Instagram</span>
//       </h2>

//       {/* Grid */}
//       <div className="grid grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
//         {posts.map((post, index) => (
//           <div
//             key={post.id}
//             className="relative group cursor-pointer overflow-hidden"
//             onClick={() => setSelectedIndex(index)}
//           >
//             <img
//               src={
//                 post.media_type === "VIDEO"
//                   ? post.thumbnail_url
//                   : post.media_url
//               }
//               alt={post.caption || "Instagram Post"}
//               className="w-full h-40 sm:h-52 md:h-60 object-cover transition-transform duration-500 group-hover:scale-105"
//             />

//             {/* Hover Overlay */}
//             <div className="absolute inset-0 bg-black/50 flex flex-col justify-center items-center text-white opacity-0 group-hover:opacity-100 transition-all duration-300">
//               <FaInstagram className="text-3xl mb-2" />
//               <p className="text-xs text-center px-2 line-clamp-2">
//                 {post.caption || "Instagram Post"}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Popup */}
//       {selectedPost && (
//         <div
//           className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-3 md:p-6"
//           onClick={() => setSelectedIndex(null)}
//         >
//           <div
//             onClick={(e) => e.stopPropagation()}
//             className="relative bg-white w-full max-w-[1000px] h-[600px] rounded-xl overflow-hidden flex flex-col md:flex-row shadow-xl"
//           >
//             {/* Media */}
//             <div className="relative w-full md:w-1/2 h-full bg-black flex items-center justify-center overflow-hidden">
//               {selectedPost.media_type === "VIDEO" ? (
//                 <video
//                   src={selectedPost.media_url}
//                   controls
//                   autoPlay
//                   muted
//                   className="w-full h-full object-cover"
//                 />
//               ) : (
//                 <img
//                   src={selectedPost.media_url}
//                   alt={selectedPost.caption}
//                   className="w-full h-full object-cover"
//                 />
//               )}

//               <button
//                 onClick={prevPost}
//                 className="absolute left-3 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black text-white p-2 rounded-full"
//               >
//                 <IoIosArrowBack size={20} />
//               </button>
//               <button
//                 onClick={nextPost}
//                 className="absolute right-3 top-1/2 -translate-y-1/2 bg-black/60 hover:bg-black text-white p-2 rounded-full"
//               >
//                 <IoIosArrowForward size={20} />
//               </button>
//             </div>

//             {/* Caption */}
//             <div className="p-6 flex flex-col justify-between w-full md:w-1/2 overflow-y-auto">
//               <div>
//                 <h2 className="text-lg font-semibold mb-2 flex items-center gap-2">
//                   <FaInstagram className="text-pink-600" />
//                   @bakelore.in
//                 </h2>
//                 <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">
//                   {selectedPost.caption}
//                 </p>
//               </div>

//               <button
//                 onClick={() => setSelectedIndex(null)}
//                 className="mt-6 self-end bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default InstagramGrid;




import React, { useEffect, useState } from "react";
import { FaInstagram } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

const ACCESS_TOKEN =
  "IGAAeKtZCMOxAZABZAGFHS1VhSF9tYjUwMlNSeFptTF8teHMtSFBKS1ZAJS0JqYmhEUnJRdWtubkM4RnV0VG5BU3NUeTM1S1lmUjNlRmJwcmVLMzdLZAWNlSFZAzVWNtQzhkcnE1WnRYQzlSR0stMlU0RzdUd043ZAWlxaWdVV2huRWJTUQZDZD";

const InstagramGrid = () => {
  const [posts, setPosts] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    fetch(
      `https://graph.instagram.com/me/media?fields=id,caption,media_url,permalink,media_type,thumbnail_url,timestamp&access_token=${ACCESS_TOKEN}`
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.data) setPosts(data.data.slice(0, 8));
      })
      .catch((err) => console.error(err));
  }, []);

  const selectedPost = selectedIndex !== null ? posts[selectedIndex] : null;

  const nextPost = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev + 1) % posts.length);
  };

  const prevPost = (e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev - 1 + posts.length) % posts.length);
  };

  return (
    <section className="bg-white py-8">
      <h2
        className="text-center text-2xl md:text-3xl font-semibold mb-8"
        style={{ fontFamily: "Philosopher, serif" }}
      >
        Follow us on <span className="text-[#C08B89]">Instagram</span>
      </h2>

      {/* Grid */}
      <div className="grid grid-cols-3 md:grid-cols-4 gap-[2px] px-4">
        {posts.map((post, index) => (
          <div
            key={post.id}
            className="relative cursor-pointer overflow-hidden"
            onClick={() => setSelectedIndex(index)}
          >
            <img
              src={
                post.media_type === "VIDEO"
                  ? post.thumbnail_url
                  : post.media_url
              }
              alt=""
              className="w-full h-36 sm:h-48 md:h-60 object-cover"
            />
          </div>
        ))}
      </div>

      {/* Popup */}
      {selectedPost && (
        <div
          className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center px-3"
          onClick={() => setSelectedIndex(null)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white w-full max-w-[1000px] 
                       h-[90vh] md:h-[600px]
                       rounded-xl overflow-hidden
                       flex flex-col md:flex-row"
          >
            {/* Media */}
            <div className="relative w-full md:w-1/2 h-[55%] md:h-full bg-black">
              {selectedPost.media_type === "VIDEO" ? (
                <video
                  src={selectedPost.media_url}
                  controls
                  autoPlay
                  muted
                  className="w-full h-full object-cover"
                />
              ) : (
                <img
                  src={selectedPost.media_url}
                  alt=""
                  className="w-full h-full object-cover"
                />
              )}

              {/* Arrows */}
              <button
                onClick={prevPost}
                className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/60 text-white p-1.5 rounded-full"
              >
                <IoIosArrowBack size={18} />
              </button>
              <button
                onClick={nextPost}
                className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/60 text-white p-1.5 rounded-full"
              >
                <IoIosArrowForward size={18} />
              </button>
            </div>

            {/* Caption */}
            <div className="w-full md:w-1/2 h-[45%] md:h-full p-4 md:p-6 overflow-y-auto">
              <h2 className="text-base font-semibold mb-2 flex items-center gap-2">
                <FaInstagram className="text-pink-600" />
                @bakelore.in
              </h2>

              <p className="text-gray-700 text-sm leading-relaxed whitespace-pre-line">
                {selectedPost.caption}
              </p>

              <button
                onClick={() => setSelectedIndex(null)}
                className="mt-4 bg-gray-900 text-white px-4 py-2 rounded-md text-sm"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default InstagramGrid;
